(function () {
    'use strict';

    function utilities($filter, settings ) { 
 
        var service = { 
        };

        return service;
    }

    angular
        .module('jcsfApp')
        .factory('utilities', utilities);

    utilities.$inject = ['$filter', 'settings' ];
})();